module.exports = __webpack_public_path__ + "img/camera.c56f3441.svg";